<template>
  <dx-modal :value="show" :title="`Adicionar guias ao lote ${batch.number}`" size="lg"
            id="modal-batch-add-guides" :closable="!saving" @input="close()">
    <div class="stenci-group stenci-alert">
      <p>
        {{ scopeLabel }}
        O título a receber e os repasses são recalculados na hora.
        Restam {{ remaining }} {{ remaining === 1 ? 'vaga' : 'vagas' }} de {{ limit }}.
      </p>
    </div>
    <div class="add-guides-work">
      <candidates-panel
        ref="candidates"
        :plan-id="planId"
        :insurance-id="insuranceId"
        :fixed-type="batch.guideType"
        :allow-mixed="allowMixed"
        :selected.sync="selected"
        compact
        @loaded="onLoaded"
        @open-guide="$emit('open-guide', $event)"
      />
      <batch-live-panel
        :guides="selected"
        :limit="remaining"
        :forecast="forecast"
        :rule="rule"
        :allow-mixed="allowMixed"
        :plan-name="planName"
        :type="batch.guideType"
        :can-create="true"
        adding
        :auto-split="false"
        :expected-payment-at="expectedPaymentAt"
        :building="saving"
        @build="save"
        @clear="selected = []"
      />
    </div>
    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: saving}" :disabled="saving || selected.length === 0 || overLimit"
              @click="save">
        <fa-icon :icon="['fal', 'plus']"/>
        {{ selected.length === 0
          ? 'Adicionar guias'
          : `Adicionar ${selected.length} ${selected.length === 1 ? 'guia' : 'guias'}` }}
      </button>
      <button class="btn" :disabled="saving" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import moment from 'moment';
import { guideTypeName, idOf } from '../service';
import CandidatesPanel from '../components/CandidatesPanel.vue';
import BatchLivePanel from '../components/BatchLivePanel.vue';

export default {
  components: {
    CandidatesPanel,
    BatchLivePanel,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      selected: [],
      limit: 100,
      rule: null,
      allowMixed: false,
    };
  },
  computed: {
    planId() {
      return idOf(this.batch.insurance.plan);
    },
    insuranceId() {
      return idOf(this.batch.insurance);
    },
    planName() {
      return `${this.batch.insurance.name} · ${this.batch.insurance.plan.name}`;
    },
    scopeLabel() {
      if (this.allowMixed) {
        return 'Guias abertas do mesmo plano entram neste lote; consulta e SP/SADT podem ir juntas.';
      }
      return `Só guias abertas do mesmo plano e tipo (${guideTypeName(this.batch.guideType)}) entram neste lote.`;
    },
    remaining() {
      return Math.max(0, this.limit - (this.batch.quantity || 0));
    },
    overLimit() {
      return this.selected.length > this.remaining;
    },
    expectedPaymentAt() {
      const manual = this.batch.expectedPayment && this.batch.expectedPayment.source === 'manual';
      return manual && this.batch.dates && this.batch.dates.expectedPaymentAt
        ? moment(this.batch.dates.expectedPaymentAt).format('YYYY-MM-DD')
        : null;
    },
    forecast() {
      const expected = this.batch.expectedPayment || {};
      return {
        date: this.batch.dates ? this.batch.dates.expectedPaymentAt : null,
        basis: expected.basis,
        cycle: expected.cycle || null,
        estimated: !!expected.estimated,
      };
    },
  },
  methods: {
    guideTypeName,
    onLoaded({ plan }) {
      if (!plan) return;
      this.limit = plan.limit || this.limit;
      this.rule = plan.paymentRule || null;
      this.allowMixed = !!plan.allowMixedBatches;
    },
    save() {
      if (this.selected.length === 0 || this.overLimit) return;
      this.saving = true;
      const accountIds = this.selected.map(({ id }) => id);
      this.$http.post(`/billing-batches/${this.batch.id}/guides`, { accountIds })
        .then(({ data }) => {
          this.$toast.success(accountIds.length === 1
            ? 'Guia adicionada ao lote.'
            : `${accountIds.length} guias adicionadas ao lote.`);
          this.$emit('added', data);
          this.$emit('close', true);
        })
        .catch((e) => {
          this.$toast.error(e);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    close(added = false) {
      if (this.saving) return;
      this.$emit('close', added);
    },
  },
};
</script>

<style lang="scss">
@import "../batch.scss";

#modal-batch-add-guides {
  .add-guides-work {
    align-items: start;
    display: grid;
    gap: $layout-spacing-lg;
    grid-template-columns: minmax(0, 1fr) 15rem;
    .cr-panel {
      margin-top: 0;
    }
    .batch-live {
      position: static;
      .batch-live-foot {
        display: none;
      }
    }
  }
  @media screen and (max-width: $size-md) {
    .add-guides-work {
      grid-template-columns: 1fr;
    }
  }
}
</style>
